<template>
	<div if="show_body" class="pr">
		<!--  -->
		<div class="head pr">
			<div>
				<img src="@a/ass_result_icon_headBg.png" alt="" />
			</div>
			<div class="pa h-box">
				<div>
					<p class="text-right asp_date">{{obj.coursename}}</p>
					<div class="user_ico text-center">
						<img :src="obj.head_img" style="vertical-align: top;" alt="" />
					</div>
					<p class="ass_type text-center">{{obj.fullname}}</p>
				</div>
				<div class="head_ol">
					<div class="ol_item">
						<div class="pa ol-label">职业背景 ：</div>
						<p>{{obj.describe}}</p>
					</div>
					<div class="ol_item">
						<div class="pa ol-label">个人标签 ：</div>
						<p v-for="item in obj.keyword">{{item}}</p>
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="info_cart pr">
			<div class="cart-bg">
				<div>
					<img src="@a/ass_result_icon_result_conBg.png" alt="" />
				</div>
			</div>
			<div class="pa car-con">
				<div>
					<!--  -->
					<div class="qr_info">
						<div class="qr_text">
							<p>扫码加我微信抱你加入小组群</p>
							<p>一起开启个人战略PBL之旅!</p>
						</div>
						<div class="qr_img">
							<img :src="obj.wechat_qrcode" alt="" />
						</div>
					</div>
					<!--  -->
					<div class="synopsis">嗨！{{obj.name}}同学你好！我是{{obj.fullname}}，PBL学习促动师，也是你即将加入的小组助教。很高兴能和你在这堂最靠谱的职业发展课相遇，在接下来一个月内，我将全程陪跑，支持你们：</div>
					<!--  -->
					<div class="list_tag">
						<ul>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_1.png" alt="" />
									</div>
									<div class="tag_text">完成9次深度的线上小组语音会</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_2.png" alt="" />
									</div>
									<div class="tag_text">拿到1份深度调研后的行业报告</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_3.png" alt="" />
									</div>
									<div class="tag_text">学会1套对标人物路径分析指南</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_4.png" alt="" />
									</div>
									<div class="tag_text">完成1次个人能力优势全面探索</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_5.png" alt="" />
									</div>
									<div class="tag_text">制定1张个人职业发展战略地图</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_6.png" alt="" />
									</div>
									<div class="tag_text">带你精准的链接更多机会和资源</div>
								</div>
							</li>
							<li>
								<div class="tag_box">
									<div class="tag_ico">
										<img src="@a/ass_result_icon_7.png" alt="" />
									</div>
									<div class="tag_text">明确未来2-3年的职业发展路径</div>
								</div>
							</li>
						</ul>
					</div>
					<!--  -->
					<div class="encourage">
						只为更快更好的职业发展<br/>一起加油！
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getTutorInfo } from "@/api/assistant"
	export default {
		data(){
			return {
				show_body: false,
				obj: {
					head_img: "",
					wechat_qrcode: "",
					describe: "",
					keyword: ["", "", ""],
					name: "",
					coursename: ""
				}
			}
		},
		methods: {
			pullData(){
				getTutorInfo({
					cid: this.$route.query.cid,
					tid: this.$route.query.tid
				})
				.then((data) => {
					this.obj = data;
					if(this.obj.keyword) {
						this.obj.keyword = data.keyword.split("&");
					}
					this.show_body = true;
				})
			}
		},
		created(){
			this.pullData();
		}
	}
</script>
<style lang="scss" scoped>
	img{
		max-width: 100%;
		height: 100%;
		width: 100%;
	}
	.mt_55{
		margin-top: 55px;
	}
	.h-box{
		left: 0;
		right: 0;
		top: 0;
		color: #fff;
		font-size: 28px;
		.asp_date{
			padding-right: 24px;
			margin-top: 30px;
			font-size: 30px;
		}
		.user_ico{
			width: 154px;
			height: 154px;
			margin: 0 auto;
			border-radius: 77px;
			border: 4px solid #fff;
			overflow-y: hidden;
		}
		.ass_type{
			margin-top: 20px;
		}
	}
	.head_ol{
		margin-top: 30px;
		.ol_item{
			padding-left: 165px;
			position: relative;
			height: 85px;
			.ol-label{
				left: 0;
				top: 0;
				padding-left: 24px;
			}
		}
	}
	.info_cart{
		background-color: #FDF9F5;
		margin-bottom: -50px;
	}
	.cart-bg{
		padding: 0 15px;
		// margin-top: -130px;
		transform: translateY(-130px);
		// padding-bottom: 67px;
	}
	.car-con{
		left: 0;
		top: 0;
		right: 0;
		font-size: 28px;
		padding: 30px 50px;
		transform: translateY(-130px);
		// background-color: #FDF9F5;
		.qr_info{
			padding-bottom: 24px;
			border-bottom: 3px solid #8B725E;
			height: 114px;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.qr_text{
			color: #8B725E;
			flex: 1;
		}
		.qr_img{
			width: 90px;
			height: 90px;
			margin-right: 8px;
			img{
				vertical-align: top;
				background: #BCB2B2;
			}
		}
		.synopsis{
			color: #333;
			margin-top: 52px;
		}
		.list_tag{
			margin-top: 53px;
			li{
				margin-bottom: 27px;
			}
			.tag_box{
				height: 59px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			.tag_ico{
				width: 59px;
				height: 59px;
				margin-right: 83px;
				margin-left: 42px;
			}
		}
	}
	.encourage{
		font-size: 36px;
		color: #8B725E;
		line-height: 62px;
		margin-top: 57px;
		text-align: center;
		// font-style: italic;
	}
</style>